export const getFlex = ({ spaces }) => {
  return {
    flexColumnGaps: spaces.gaps.column,
    flexRowGaps: spaces.gaps.row,
  }
}
